import React, { memo } from 'react'
import tw from 'twin.macro'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'

type AddressPart = 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'zipCode' | 'country'

interface Props {
  /** Maps each address part to the FLAT form field holding it (e.g. `businessCity`). */
  fieldNames: Record<AddressPart, string>
}

/**
 * One address block bound to flat, prefixed fields — the Formik wrappers cannot read nested
 * paths. The wrappers are typed `<any>` here on purpose: the caller's field map is the contract,
 * and every call site passes keys of `BankOnboardingFormValues` / `BeneficialOwnerFormValues`.
 * `css` on a text field lands on the MUI input, not the grid cell, so spans use a wrapper div.
 */
const OnboardingAddressFieldsComponent = ({ fieldNames }: Props) => {
  return (
    <div css={tw`grid grid-cols-2 gap-4`}>
      <div css={tw`col-span-2`}>
        <FormikTextField<any>
          name={fieldNames.addressLine1}
          label="Address line 1 *"
          placeholder="Street address"
        />
      </div>
      <div css={tw`col-span-2`}>
        <FormikTextField<any>
          name={fieldNames.addressLine2}
          label="Address line 2"
          placeholder="Suite, unit (optional)"
        />
      </div>
      <FormikTextField<any> name={fieldNames.city} label="City *" placeholder="City" />
      <FormikTextField<any> name={fieldNames.state} label="State *" placeholder="e.g. TX" />
      <FormikTextField<any> name={fieldNames.zipCode} label="ZIP code *" placeholder="ZIP" />
      <FormikTextField<any>
        name={fieldNames.country}
        label="Country *"
        placeholder="US"
        inputProps={{ maxLength: 2 }}
      />
    </div>
  )
}

export const OnboardingAddressFields = memo(OnboardingAddressFieldsComponent)
